import { api } from '@/shared/api/client';
import type { VerifyEmailRequest } from '../model/dto';

export const postAuthVerifyEmail = async (payload: VerifyEmailRequest) => {
  const { data } = await api.post('/auth/verify-email/', payload);
  return data;
};
